
function getMobileOperatingSystem() {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

const waitSms = 'لطفا تا دریافت پیام از دستگاه صبر کنید';
const checkInput = 'داده های ورودی را بررسی بفرمایید';

function checkNumber(temp) {
    //console.log('number(checkNumber)', temp)
    if (temp.startsWith("0")) {
        temp = temp.slice(1, temp.length);
        console.log('1', temp)
    }
    if (temp.startsWith("0")) {
        temp = temp.slice(1, temp.length);
        console.log('2', temp)
    }
    if (!temp.startsWith("98")) {
        temp = "98" + temp;
        console.log('3', temp)
    }
    return temp;
}

function sendSms(phone, href) {
    phone = checkNumber(phone);
    const link = document.createElement('a');
    let charPhone = '?';
    const device = getMobileOperatingSystem();
    if (device == "iOS")
        charPhone = "&";

    link.href = `sms:${phone}${charPhone}body=${href}`;
    //link.setAttribute('download', 'file.pdf');
    document.body.appendChild(link);
    console.log('sms', link.href)
    link.click();
}


export default {
    checkNumber, waitSms, checkInput,
    sendSms, getMobileOperatingSystem



}